const toggle = document.querySelector(".masthead-toggle > a");
if (toggle) {
    toggle.addEventListener("click", (e) => {
        e.preventDefault();
        toggle.closest(".masthead").classList.toggle("masthead-nav--open");
    });
}
export default undefined;
